<template>
	<div class="pay-page-box">
		<div class="dialog-title-box">
			<div style="display: flex;">
				<div class="line-box"></div>
				<div class="title-big-text">
					订单支付
					<span v-if="orgin === 'muti'" style="margin-left: 10px;color: #595959;font-size: 12px;">(已选：{{orderIds.length}}, 已支付：{{payNum}}, 剩余：{{noPayNum}})</span>
				</div>
			</div>
			<i class="el-icon-close close-btn" @click="closeClick"></i>
		</div>
		<div class="dialog-body-box">
			<div class="order-detail-box">
				<div class="arrow-box" v-show="orgin !=='detail'">
					<img v-if="hasUp" @click="upClick" class="arrow-icon" src="~/images/icon/up-icon.png" />
					<img v-else class="arrow-icon" src="~/images/icon/dis-up-icon.png" />
					上一单
				</div>
				<div class="order-detail">
					<div class="order-detail-row">
						<div style="flex: 1;text-align: left;">极速订客户：{{customerName}}</div>
						<div style="flex: 1;text-align: left;">订单号：{{orderNumber}}</div>
					</div>
					<div class="order-detail-row">
						<div style="flex: 1;text-align: left;">金额：
							<span style="font-weight: bold;">￥{{needPayMoney}}</span>
						</div>
					</div>
				</div>
				<div class="arrow-box" v-show="orgin !=='detail'">
					<img v-if="hasNext" @click="nextClick" class="arrow-icon" src="~/images/icon/next-icon.png" />
					<img v-else class="arrow-icon" src="~/images/icon/dis-next-icon.png" />
					下一单
				</div>
			</div>
			<div v-if="!payResult">
				<div class="tip-box">
					<el-tooltip class="item" effect="dark" content="补款时支付方式需与首次支付相同" placement="top-start">
						<i class="el-icon-warning" style="color: var(--fx-primary-color);"></i>
					</el-tooltip>
					请选择支付方式（获取客户档案中绑定的支付方式，目前只支持微信支付，微企付、线下支付）
				</div>
				<div v-if="paymodes.length > 0" class="pay-way-box">
					<div v-if="showWx" :class="payWay === '2' ? 'is-select-btn pay-btn' : 'pay-btn'" @click="payWayChange('2')">微信支付</div>
					<div v-if="showWqf" :class="payWay === '6' ? 'is-select-btn pay-btn' : 'pay-btn'" @click="payWayChange('6')">微企付</div>
					<div v-if="showOffline" :class="payWay === '0' ? 'is-select-btn pay-btn' : 'pay-btn'" @click="payWayChange('0')">线下支付</div>
				</div>
				<div v-if="(payWay === '2' || payWay === '6') && paymodes.length > 0">
					<div class="img-box">
						<w-image style="width: 100%;height: 100%;" :src="imgSrc"></w-image>
						<div class="mask-box"  v-if="isTimeOut">
							<el-button type="primary" size="mini" @click="getImg()">重新获取</el-button>
						</div>
					</div>
					<div style="color: #595959;font-size: 12px;" v-if="showtime">使用微信扫一扫付款
						<span style="color: var(--fx-primary-color);font-size: 14px;">{{time}}s</span>
					</div>
				</div>
				<div v-if="paymodes.length === 0" class="no-pay-way-box">
					<div style="margin-bottom: 30px;">当前客户未绑定可使用的支付方式</div>
					<div>
						<el-button size="mini" type="primary" @click="goSetting">前往客户档案绑定</el-button>
					</div>
				</div>
				<div class="money-box">
					<img style="width: 21px;height: 21px;margin-right: 5px;" src="~/images/icon/qiandai.png" />
					待支付金额：
					<span style="color: #EC4141;font-size: 18px;">￥{{bePayMoney}}</span>
				</div>
				<div v-if="payWay === '0'" style="margin-top: 30px;">
					<el-button size="mini" type="primary" @click="payClick">确定支付</el-button>
				</div>
			</div>
			<div v-if="payResult" class="result-box">
				<img v-if="isSuccess" class="result-img" src="~/images/icon/success@2x.png" />
				<img v-if="!isSuccess" class="result-img" src="~/images/icon/fail@2x.png" />
				<div style="font-size: 14px;font-weight: bold;color: #333333;margin-top: 20px;">
					{{isSuccess ? '支付成功！' : '订单已失效/订单已支付'}}
				</div>
				<div v-if="isSuccess" style="color: #595959;margin-top: 20px;">
					<span v-if="payWay ==='2'">微信支付</span>
					<span v-if="payWay ==='6'">微企付</span>
					<span v-if="payWay ==='0'">线下支付</span>
				</div>
				<div style="margin-top: 50px;">
					<el-button size="mini" @click="closeClick">支付完成</el-button>
					<el-button size="mini" type="primary" v-if="orgin !== 'detail' && hasNext" @click="nextClick">支付下一单</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'mainTable',
	props: {
		orderIds: {
			type: Array,
			default: () => []
		},
		id: {
			type: String
		},
		orgin: {
			type: String
		}
	},
	data () {
		return {
			paymodes: [],
			needPayMoney: '',
			orderNumber: '',
			customerName: '',
			hasUp: false,
			hasNext: false,
			payWay: null,
			time: 120,
			imgSrc: '',
			bePayMoney: '',
			timer: null,
			customerId: '',
			isTimeOut: false,
			payResult: false,
			showWx: false,
			showWqf: false,
			showOffline: false,
			showtime: false,
			isSuccess: false,
			index: 0,
			showOrderList: [],
			nextId: '',
			upId: '',
			payNum: 0,
			noPayNum: 0
		}
	},
	created () {
		if (this.orgin !== 'muti') {
			this.orderId = this.id
			this.getDetail()
		} else {
			this.showOrderList = this.initMuti(this.orderIds)
			this.orderId = this.showOrderList[this.index].orderId
			this.checkMuti()
			this.getDetail()
		}
	},
	beforeDestroy () {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		checkMuti () {
			let payNum = 0
			let noPayNum = 0
			console.log(this.showOrderList)
			this.showOrderList.forEach((item, index) => {
				if (item.isShow) {
					noPayNum++
				} else {
					payNum++
				}
				if (item.orderId === this.orderId) {
					this.index = index
				}
			})
			this.payNum = payNum
			this.noPayNum = noPayNum
			this.checkMutiUp()
			this.checkMutiNext()
		},
		checkMutiUp () {
			let num = this.index - 1
			let list = this.showOrderList
			let flag = false
			let id = ''
			for (let i = num; i > -1; i--) {
				if (!flag && list[i].isShow) {
					id = list[i].orderId
					flag = true
				}
			}
			this.upId = id
			this.hasUp = flag
		},
		checkMutiNext () {
			let num = this.index + 1
			let list = this.showOrderList
			let flag = false
			let id = ''
			for (let i = num; i < list.length; i++) {
				if (!flag && list[i].isShow) {
					id = list[i].orderId
					flag = true
				}
			}
			this.nextId = id
			this.hasNext = flag
		},
		initAll () {
			this.payResult = false
			clearInterval(this.timer)
			this.timer = null
		},
		upClick () {
			this.orderId = this.upId
			this.initAll()
			this.getDetail()
		},
		nextClick () {
			this.orderId = this.nextId
			this.initAll()
			this.getDetail()
		},
		initMuti (list) {
			let arr = []
			list.forEach(item => {
				let row = {
					isShow: true,
					orderId: item
				}
				arr.push(row)
			})
			return arr
		},
		payClick () {
			let params = {
				customerId: this.customerId,
				paymode: 0,
				orderid: this.orderId,
				payMoney: this.bePayMoney
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSV}/order/pay/single`,
				data: params
			}).then(res => {
				if (res.result) {
					this.payResult = true
					this.isSuccess = true
					if (this.orgin === 'muti') {
						this.showOrderList[this.index].isShow = false
						this.checkMuti()
					}
				} else {
					this.payResult = true
					this.isSuccess = false
					if (this.orgin === 'muti') {
						this.showOrderList[this.index].isShow = false
						this.checkMuti()
					}
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		goSetting () {
			this.$router.push(`/main/customer`)
			this.$fxEventBus.$emit('setMenu', '5-1')
		},
		check () {
			this.time = this.time - 1
			if (this.time < 0) {
				this.isTimeOut = true
				this.showtime = false
				clearInterval(this.timer)
				this.timer = null
				return false
			}
			let params = {
				paymentmode: this.payWay === '2' ? 2 : 6,
				orderid: this.orderId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.nfUrl}order/pay/statequery`,
				loading: false,
				data: params
			}).then(res => {
				if (res.result) {
					this.payResult = true
					this.isSuccess = true
					this.showtime = false
					if (this.orgin === 'muti') {
						this.showOrderList[this.index].isShow = false
						this.checkMuti()
					}
					clearInterval(this.timer)
					this.timer = null
				}
			})
		},
		loop () {
			this.timer = setTimeout(() => {
				this.check()
				this.loop()
			}, 1000)
		},
		getImg () {
			let params = {
				customerId: this.customerId,
				paymode: this.payWay === '2' ? 2 : 6,
				orderid: this.orderId,
				payMoney: this.bePayMoney
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSV}/order/pay/single`,
				data: params
			}).then(res => {
				if (res.result) {
					this.imgSrc = 'data:image/png;base64,' + res.data.code_base64
					this.isTimeOut = false
					this.showtime = true
					this.time = 120
					this.loop()
				} else {
					this.payResult = true
					this.isSuccess = false
					if (this.orgin === 'muti') {
						this.showOrderList[this.index].isShow = false
						this.checkMuti()
					}
					// this.$message.error(res.msg)
				}
			})
		},
		getDetail () {
			let params = {
				orderId: this.orderId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findPayDetail`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data
					this.customerId = data.customerId
					this.customerName = data.customerName
					this.orderNumber = data.orderNumber
					this.needPayMoney = data.needPayMoney
					this.bePayMoney = data.bePayMoney
					this.paymodes = data.paymodes
					this.showWx = data.paymodes.indexOf('2') !== -1
					this.showWqf = data.paymodes.indexOf('6') !== -1
					this.showOffline = data.paymodes.indexOf('0') !== -1
					if (data.paymodes.length > 0) {
						this.payWay = data.paymodes[0]
						if (this.payWay === '2' || this.payWay === '6') {
							this.getImg()
						}
					}
					if (this.orgin === 'muti') {
						this.checkMuti()
					}
					if (this.orgin === 'list') {
						this.checkPreOrder()
						this.checkNextOrder()
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		checkPreOrder () {
			let params = {
				orderid: this.orderId,
				fromAllFlag: true,
				payFlag: true
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/previous`,
				data: params
			}).then(res => {
				this.hasUp = res.result
				if (res.result) {
					this.upId = res.data.orderid
				}
			})
		},
		checkNextOrder () {
			let params = {
				orderid: this.orderId,
				fromAllFlag: true,
				payFlag: true
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/next`,
				data: params
			}).then(res => {
				this.hasNext = res.result
				if (res.result) {
					this.nextId = res.data.orderid
				}
			})
		},
		payWayChange (data) {
			if (data === this.payWay) {
				return false
			}
			clearInterval(this.timer)
			this.timer = null
			this.showtime = false
			this.payWay = data
			if (data !== '0') {
				this.getImg()
			}
		},
		closeClick () {
			this.$emit('closeHandler')
		}
	}
}
</script>
<style lang="stylus">
.pay-page-box {
	font-size: 12px;
	color: #333333;
	/* .page-box{
		font-size: 12px;
		color: #333333;
	} */
	.dialog-title-box{
		height: 50px;
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		margin: 0 20px;
		border-bottom: 1px solid #EEEEEE;
		align-items: center;
		justify-content: space-between;
	}
	.line-box{
		width: 4px;
		height: 20px;
		background-color: var(--fx-primary-color);
		margin-right: 10px;
	}
	.title-big-text{
		font-size: 16px;
		color: #333333;
		font-weight: bold
	}
	.close-btn{
		font-size: 20px;
		color: #BCC2CC;
		float: right;
		cursor: pointer;
	}
	.dialog-body-box{
		padding: 10px 20px;
	}
	.order-detail-box{
		display: flex;
		flex-direction: row;
		margin-top: 10px;
		height: 76px;
	}
	.order-detail{
		flex: 1;
		height: 100%;
		background-color: #F7F9FF;
	}
	.order-detail-row{
		display: flex;
		width: 100%;
		height: 38px;
		align-items: center;
		padding: 0 20px;
		box-sizing: border-box;
		color: #333333;
	}
	.arrow-box{
		cursor: pointer;
		width: 60px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.arrow-icon{
		width: 24px;
		height: 24px;
		margin-bottom: 5px;
	}
	.tip-box{
		text-align: left;
		margin-top: 50px;
	}
	.pay-way-box{
		width: 100%;
		height: 35px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		margin-top: 20px;
	}
	.pay-btn{
		width: 88px;
		height: 32px;
		box-sizing: border-box;
		border: 1px solid #E0E0E0;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 10px;
		border-radius: 4px;
		cursor: pointer;
	}
	.is-select-btn{
		color: #FFFFFF;
		background-color: var(--fx-primary-color);
		border: var(--fx-primary-color);
	}
	.img-box{
		width: 200px;
		height: 200px;
		margin: 20px auto;
		position: relative;
	}
	.mask-box{
		position :absolute;
		width :100%;
		height :100%;
		background-color :rgba(0,0,0,0.1);
		display:flex;
		align-items :center;
		justify-content :center;
		top:0;
		left:0
	}
	.money-box{
		height: 40px;
		margin-top: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	.no-pay-way-box{
		height: 200px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.result-box{
		height: 300px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.result-img{
		width: 50px;
		height: 50px;
	}
}
</style>
